export default "__VITE_ASSET__Au0mBpRT__"